import ShopByPetPreview from './shop-by-pet-preview.component';

export default ShopByPetPreview;
